import axios from 'axios';

import {
    GetAllLearningResourceQueryParams,
    ILearningResource,
    PagedApiResponseBody,
} from '@sparkplug/lib';

import { useAdvancedQuery } from '@hooks/QueryHooks';

const API = {
    getAllCourses: async ({
        limit = '10',
        offset = '0',
        order = 'asc',
        sort,
        status,
        accountId,
        brandId,
        billingMode,
        market,
        q,
        locationIds,
        launchedAtStart,
        launchedAtEnd,
    }: GetAllLearningResourceQueryParams) => {
        return (
            await axios.get<PagedApiResponseBody<ILearningResource>>('/api/v1/learning-resource', {
                params: {
                    limit,
                    offset,
                    order,
                    sort,
                    status,
                    accountId,
                    brandId,
                    billingMode,
                    market,
                    q,
                    locationIds,
                    launchedAtStart,
                    launchedAtEnd,
                },
            })
        ).data;
    },
};

export const coursesCacheKey = 'courses';

export const useGetAllCoursesQuery = (params: GetAllLearningResourceQueryParams) => {
    const { data, isLoading, error } = useAdvancedQuery(
        [coursesCacheKey, params],
        () => API.getAllCourses(params),
        {
            refetchOnMount: true,
            enabled: Number.isFinite(Number(params.limit)),
        },
    );

    return {
        courses: data?.data ?? [],
        meta: data?.meta,
        isLoadingCourses: isLoading,
        coursesError: error,
    };
};

export const useGetAllAccountCourses = (params: GetAllLearningResourceQueryParams) => {
    const { data, isLoading, error } = useAdvancedQuery(
        [coursesCacheKey, params],
        () => API.getAllCourses(params),
        {
            refetchOnMount: true,
            enabled: Number.isFinite(Number(params.limit)),
        },
    );

    return {
        courses: data?.data ?? [],
        meta: data?.meta,
        isLoadingCourses: isLoading,
        coursesError: error,
    };
};
